import React from 'react';
import './css/about.css';
import { useTranslation } from 'react-i18next';

function AboutUs() {
  const { t } = useTranslation();
  const introRaw = t('aboutUs.intro.description');
  const paragraphs = introRaw
    .trim()
    .split(/\n\s*\n/)
    .map(p => p.replace(/^\s+/gm, ''));

  return (
    <div className="about-us-page min-h-screen">
      {/* Hero Section */}
      <section className="hero-section relative text-white py-20">
        <div className="absolute inset-0 bg-black bg-opacity-70"></div>
        <div className="container mx-auto px-4 relative z-10">
          <h1 className="text-5xl font-bold mb-4">{t('aboutUs.hero.title')}</h1>
          <p className="text-xl text-white">{t('aboutUs.hero.subtitle')}</p>
        </div>
      </section>

      {/* Company Introduction */}
      <section className="company-intro py-16 bg-white">
        <div className="container mx-auto px-4">
          <h2 className="text-4xl font-bold mb-8 text-center">{t('aboutUs.intro.title')}</h2>
          <div className="max-w-4xl mx-auto">
            {paragraphs.map((p, i) => (
              <p key={i} className="text-lg text-gray-700 leading-relaxed mb-6">
                {p}
              </p>
            ))}
            {/* 若想簡單保留原始換行可改用：
            <p className="text-lg text-gray-700 leading-relaxed whitespace-pre-line text-center">
              {introRaw}
            </p>
            */}
          </div>
        </div>
      </section>
    </div>
  );
}

export default AboutUs;
